var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyteCameraMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2585 6.06973L12.7697 7.28405C12.8311 7.42904 12.9947 7.51966 13.1583 7.51966H14.5896C15.2848 7.51966 15.8165 7.99089 15.8165 8.60711V12.9569C15.8165 13.5731 15.2848 14.0443 14.5896 14.0443H6.41045C5.71522 14.0443 5.18357 13.5731 5.18357 12.9569V8.60711C5.18357 7.99089 5.71522 7.51966 6.41045 7.51966H7.8418C8.02583 7.51966 8.16897 7.42904 8.23031 7.28405L8.74151 6.06973H12.2585ZM7.13088 6.01335H6.41045C5.05923 6.01335 3.67725 6.99332 3.67725 8.60711V12.9569C3.67725 14.5707 5.05923 15.5507 6.41045 15.5507H14.5896C15.9408 15.5507 17.3228 14.5707 17.3228 12.9569V8.60711C17.3228 6.99332 15.9408 6.01335 14.5896 6.01335H13.8692L13.6469 5.48529C13.4117 4.92668 12.8646 4.56342 12.2585 4.56342H8.74151C8.13541 4.56342 7.58835 4.92668 7.35318 5.48529L7.13088 6.01335Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 11.6519C11.1362 11.6519 11.6519 11.1362 11.6519 10.5C11.6519 9.86383 11.1362 9.34811 10.5 9.34811C9.86385 9.34811 9.34812 9.86383 9.34812 10.5C9.34812 11.1362 9.86385 11.6519 10.5 11.6519ZM10.5 13.1582C11.9681 13.1582 13.1582 11.9681 13.1582 10.5C13.1582 9.03192 11.9681 7.8418 10.5 7.8418C9.03193 7.8418 7.8418 9.03192 7.8418 10.5C7.8418 11.9681 9.03193 13.1582 10.5 13.1582Z",
    fill: "#525252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4937 3.41136C19.4937 2.35923 18.6407 1.50632 17.5886 1.50632L14.0443 1.50632L14.0443 -4.00323e-07L17.5886 -1.96337e-07C19.4727 -8.79031e-08 21 1.52732 21 3.41136L21 6.95564L19.4937 6.95564L19.4937 3.41136Z",
    fill: "#525252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50633 3.41136C1.50633 2.35923 2.35925 1.50632 3.41139 1.50632L6.95569 1.50632L6.95569 3.04043e-07L3.41139 1.49117e-07C1.52733 6.67618e-08 -6.67612e-08 1.52732 -1.49115e-07 3.41136L-3.04041e-07 6.95564L1.50633 6.95564L1.50633 3.41136Z",
    fill: "#525252"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5886 19.4937C18.6407 19.4937 19.4937 18.6408 19.4937 17.5886L19.4937 14.0444L21 14.0444L21 17.5886C21 19.4727 19.4727 21 17.5886 21L14.0443 21L14.0443 19.4937L17.5886 19.4937Z",
    fill: "#525252"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50633 17.5886C1.50633 18.6408 2.35925 19.4937 3.41139 19.4937L6.95569 19.4937L6.95569 21L3.41139 21C1.52733 21 2.63709e-07 19.4727 5.89011e-07 17.5886L1.20097e-06 14.0444L1.50633 14.0444L1.50633 17.5886Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyteCameraMobile);
export default __webpack_public_path__ + "static/media/syte-camera-mobile.0c2f7783.svg";
export { ForwardRef as ReactComponent };